export default "__VITE_ASSET__CvE4H94V__"